export default {
  depositionsHome: {
    title: ['¿Qué es', 'SIS?'],
    subtitle: '¿Qué dice nuestro equipo sobre nosotros?',
  },
}
